import {createApp} from 'vue';

import '@/css/app.scss';
import CmbvlMap from "@/vue/CmbvlMap.vue";
import ResponsiveMenu from "@/vue/ResponsiveMenu.vue";
import Accordion from "@/vue/Accordion.vue";
import CsrfInput from "@/vue/CsrfInput.vue";
import FlashMessage from "@/vue/FlashMessage.vue";
import Carrousel from "@/vue/Carrousel.vue";
import NewsletterSubscriptionForm from "@/vue/NewsletterSubscriptionForm.vue";
import CustomizableMap from "@/vue/CustomizableMap.vue";
import "@/js/utils/whatsapp-deobfuscator.ts";
import FizSubscriptionForm from "@/vue/FizSubscriptionForm.vue";
import MissingAttachmentsPage from "@/vue/FizMissingAttachmentsPage.vue";
import PassyViteUploadTrackForm from "@/vue/PassyViteUploadTrackForm.vue";
import LightSwitch from "@/vue/LightSwitch.vue";
import FileUpload from "@/vue/FileUpload.vue";

// App main
const main = async () => {
  // Create our vue instance
  const app = createApp({
    name: 'App',
    components: {
      CmbvlMap,
      ResponsiveMenu,
      Accordion,
      FlashMessage,
      CsrfInput,
      Carrousel,
      NewsletterSubscriptionForm,
      CustomizableMap,
      FizSubscriptionForm,
      MissingAttachmentsPage,
      PassyViteUploadTrackForm,
      LightSwitch,
      FileUpload,
    },
  });

  // Mount the app
  return app.mount('#vue-root');
};

// Execute async function
main().then(() => {
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept();
}
